'use client';
import { Blockquote, Button, ButtonProps } from '@ui';

import { forwardRef, useImperativeHandle, useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface Props extends Partial<ButtonProps> {
    isLoading?: boolean;
    disableErrorWarning?: boolean;
}

export interface SubmitButtonRef {
    submit: () => void;
}

const FormSubmit = forwardRef<SubmitButtonRef, Props>(({ isLoading, disableErrorWarning, ...props }: Props, ref) => {
    const { t } = useTranslation(['form', 'common']);
    const formContext = useFormContext();
    const submitRef = useRef<HTMLButtonElement>(undefined);

    useImperativeHandle(ref, () => ({
        submit: () => submitRef.current?.click()
    }));

    return (
        <>
            {!disableErrorWarning &&
                Object.keys(formContext?.formState.errors || {}).length > 0 &&
                formContext?.formState.isSubmitted && (
                    <Blockquote color="error" className="tw-my-4 tw-text-center">
                        {t('form:error.invalidData')}
                    </Blockquote>
                )}
            <Button
                auto
                block
                color="success"
                type="submit"
                isLoading={isLoading}
                className="tw-mb-2 tw-mt-4"
                {...props}
                disabled={isLoading || props.disabled}
            >
                {props.children || t('form:submit.default')}
            </Button>
            {ref && <button ref={submitRef} type="submit" className="tw-hidden" hidden aria-hidden />}
        </>
    );
});

FormSubmit.displayName = 'FormSubmit';

export default FormSubmit;
